// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"3f358cab","160":"49c1ee0a","208":"4b5e2b1e","293":"e06f636b","516":"60861a54","519":"e5736f2a","840":"60b2ee56","917":"899a0d7e","946":"b424a837"}[chunkId] + ".chunk.js";
};